// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-radio-button {
  align-items: center;
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
  display: inline-flex;
  border-radius: 0.125rem;
}
.bolt-radio-button:focus {
  outline: none;
}
.bolt-radio-button:not(.labelled) {
  border-radius: 50%;
  margin: 2px;
  height: 1rem;
  width: 1rem;
  justify-content: center;
}

.bolt-radio-button.disabled {
  cursor: default;
  color: rgba(0, 0, 0, .38);
  color: var(--text-disabled-color,rgba(0, 0, 0, .38));
}
@media (forced-colors: active) {
  .bolt-radio-button.disabled {
    color: grayText;
  }
}

.bolt-radio-button.labelled {
  padding: 3px 4px 3px 3px;
}

.bolt-radio-button-label {
  padding-left: 10px;
  display: flex;
  flex-direction: column;
}

.bolt-radio-button-icon {
  border: 1px solid rgba(0, 0, 0, .55);
  border: 1px solid var(--text-secondary-color,rgba(0, 0, 0, .55));
  border-radius: 50%;
  height: 1rem;
  transition: 80ms border-color linear;
  width: 1rem;
  min-width: 1rem;
}

.bolt-radio-button.checked .bolt-radio-button-icon {
  border-color: rgba(0, 120, 212, 1);
  border-color: var(--communication-background,rgba(0, 120, 212, 1));
  border-width: 0.125rem;
}

.bolt-radio-button.disabled .bolt-radio-button-icon {
  border-color: rgba( 200, 200, 200 ,  1 );
  border-color: rgba( var(--palette-neutral-20,200, 200, 200) ,  1 );
}

.bolt-radio-button-bullet {
  background-color: transparent;
  border:  1px solid;
  border-color: rgba( 255, 255, 255 ,  1 );
  border-color: rgba( var(--palette-neutral-0,255, 255, 255) ,  1 );
  border-radius: 50%;
  width: 0.75rem;
  height: 0.75rem;
  margin-left: 1px;
  margin-top: 1px;
  transform: scale(0.1);
}

.bolt-radio-button.checked .bolt-radio-button-bullet {
  background-color: rgba(0, 120, 212, 1);
  background-color: var(--communication-background,rgba(0, 120, 212, 1));
  margin-left: 0px;
  margin-top: 0px;
  transition: transform 80ms ease-out, background 80ms linear;
  transform: scale(1);
}
@media (forced-colors: active) {
  .bolt-radio-button.checked .bolt-radio-button-bullet {
    background-color: windowtext;
  }
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-radio-button.checked .bolt-radio-button-bullet {
  background-color: rgba(0, 90, 158, 1);
  background-color: var(--communication-foreground,rgba(0, 90, 158, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-radio-button.checked .bolt-radio-button-bullet {
  background-color: rgba(0, 90, 158, 1);
  background-color: var(--communication-foreground,rgba(0, 90, 158, 1));
}

.bolt-radio-button.checked.disabled .bolt-radio-button-bullet {
  background-color: rgba( 200, 200, 200 ,  1 );
  background-color: rgba( var(--palette-neutral-20,200, 200, 200) ,  1 );
}

.bolt-focus-visible .bolt-radio-button.bolt-focus-treatment:not(.labelled):focus {
  border-radius: 50%;
}
.bolt-focus-visible .bolt-radio-button.bolt-focus-treatment:not(.labelled):focus .bolt-radio-button-icon {
  border-color: rgba(0, 120, 212, 1);
  border-color: var(--communication-background,rgba(0, 120, 212, 1));
}
.bolt-focus-visible .bolt-radio-button.bolt-focus-treatment:not(.labelled):focus.checked .bolt-radio-button-icon {
  border-width: 0.125rem;
  box-shadow: 0 0 0 1px rgba( 255, 255, 255 ,  1 );
  box-shadow: 0 0 0 1px rgba( var(--palette-neutral-0,255, 255, 255) ,  1 );
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-radio-button.bolt-focus-treatment:not(.labelled):focus {
    border-radius: 0;
  }
}

.bolt-focus-visible .bolt-radio-button.bolt-focus-treatment:focus {
  animation: ms-focus-shadow-with-border-pulse 4s ease-in-out infinite;
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-radio-button.bolt-focus-treatment:focus {
    animation: none;
  }
}
.bolt-focus-visible .bolt-radio-button.bolt-focus-treatment:focus {
  box-shadow: 0 0 0 3px rgba(0, 120, 212, 0.23), 0 0 0 1px rgba(0, 120, 212, 1);
  box-shadow: 0 0 0 3px var(--focus-pulse-max-color,rgba(0, 120, 212, 0.23)), 0 0 0 1px var(--focus-border-color,rgba(0, 120, 212, 1));
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-radio-button.bolt-focus-treatment:focus {
    border: 1px solid windowtext;
  }
}

.bolt-radio-button-group-container .bolt-formitem-label {
  padding-left: 3px;
}

/*# sourceMappingURL=RadioButton.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/RadioButton/RadioButton.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/RadioButton/RadioButton.css","webpack://./../azure-devops-ui/src/_coreStyles.scss"],"names":[],"mappings":"AACA;EACI,mBAAA;EACA,wBC0JW;EDzJX,kDAAA;EACA,oBAAA;EEAF,uBAAuB;AFErB;AEAJ;EACE,aAAa;AFGX;AEDJ;EFGQ,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EEDN,uBAAuB;AACzB;;AAEA;EFII,eC+IY;ECjJd,yBAAyB;EC2BvB,oDAAA;ADzBJ;AACA;EACE;IACE,eAAe;EACjB;AFGF;;AEAA;EACE,wBAAwB;AFG1B;;AEAA;EFGI,kBAAA;EEDF,aAAa;EACb,sBAAsB;AFGxB;;AEAA;EFGI,oCAAA;EACA,gEAAA;EACA,kBAAA;EACA,YAAA;EEDF,oCAAoC;EACpC,WAAW;EFGb,eAAA;AEDA;;AAEA;EACE,kCAAkC;EFGpC,kEAAA;EACI,sBCkBS;ACnBb;;AFIA;EACI,wCAAA;EACA,kEAAA;AEDJ;;AAEA;EFGI,6BAAA;EACA,kBAAA;EACA,wCAAA;EEDF,iEAAiE;EACjE,kBAAkB;EFGpB,cAAA;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AEDJ;;ACxBI;EHqBJ,sCAAA;EEOE,sEFCM;EEAN,gBAAgB;EAChB,eAAe;EDyTT,2DAAA;EDtTA,mBC5DmB;AC4D3B;ADyTQ;EDzTA;IEGJ,4BAA4B;EAC9B;AFAF;AEEA;EACE,qCAAqC;EACrC,qEAAqE;AFAvE;AEEA;EACE,qCAAqC;EFAnC,qEAAA;AEEJ;;AFEI;EACI,4CAAA;EACA,sEAAA;AECR;;AAEA;EACE,kBFAM;AECR;AACA;EACE,kCAAkC;EFCpC,kEAAA;AECA;AACA;EC5DI,sBAAA;EH0DJ,gDAAA;EEKE,yEChDM;ADiDR;AACA;EFPA;IGrCQ,gBAAA;ED+CN;ACpEE;;ADuEJ;EACE,oEAAoE;AACtE;AACA;EFPI;IACI,eAAA;EESN;AACF;AACA;EACE,6EAA6E;EAC7E,oIAAoI;AACtI;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA,0CAA0C","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
